export default "__VITE_ASSET__05cc6e31__"